// filterOptions.js — dropdown option lists for the filter row.
export const filterOptions = {
  states: ['Kano', 'FCT', 'Abia', 'Adamawa', 'Benue', 'Kwara', 'Osun', 'Kogi'],
  lgas: ['Kano Municipal', 'Garko', 'Bebeji', 'Doguwa'],
  marketTypes: ['Livestock Market', 'Agro-Input Market', 'Wholesale', 'Retail'],
  statuses: ['Licensed', 'Unlicensed', 'Pending', 'Exempt'],
  categories: ['Veterinary Clinic', 'Abattoir', 'Feed Mill', 'Laboratory'],
  facilityTypes: [
    'Veterinary Clinic', 'Veterinary Hospital', 'Laboratory', 'Diagnostic Centre',
    'Live Animal Market', 'Abattoir', 'Slaughter Slab', 'Grazing Reserve',
    'Watering Point', 'Milk Collection Centre', 'Feed Mill', 'Cold Storage Commercial',
    'Cold Storage Biological', 'Breeding Farm', 'AI Centre', 'Quarantine Station',
  ],
  facilityServiceTypes: ['Clinics', 'Abattoir', 'Feed Mill'],
};
